import moment from "moment"

class Storage {
  get(item: any) {
    const request = new Promise((resolve, reject) => {
      let data = localStorage.getItem(item)
      console.log(`Start of promise`)
      data ? resolve(data) : reject()
    })

    request.then((data: any) => {
      console.log(`promise resolved`)
      console.log(JSON.parse(data))
    })

    request.catch((error) => {
      console.log(`Promise rejected`)
      console.log(error)
    })
  }

  set(name: any, data: any) {
    localStorage.setItem(name, JSON.stringify(data))
  }
}

export const Store = new Storage()

export const setTokenLocal = (token: any) => {
  localStorage.setItem("token", token)
}

export const getTokenLocal = () => {
  return localStorage.getItem("token")
}

export const deleteTokenLocal = () => {
  localStorage.removeItem("token")
}

export const clearLocalstorage = () => {
  localStorage.clear()
}

// Date and Time Helper Functions

const currentDate = new Date()

export function dateFormatter() {
  return currentDate.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    weekday: "long",
  })
}

export function getCurrentYear() {
  return moment().format("YYYY")
}

export function onlyLettersAndSpaces(str: string) {
  return /^[A-Za-z\s]*$/.test(str)
}

;("^[a-zA-Z0-9_]*$")

export function onlyNumbers(str: string) {
  return /^[0-9\b]+$/.test(str)
}

export function firstCap(str: string) {
  const firstChar = str?.charAt(0)?.toUpperCase()
  const remainingChars = str?.slice(1)
  return `${firstChar}${remainingChars}`
}

export function splitFirstCap(str: any, splitBy: string) {
  const arrayOfWords = str?.split(splitBy)

  let finalString: string = ""

  arrayOfWords?.forEach((word: any) => {
    const firstChar = word?.charAt(0)?.toUpperCase()
    const remainingChars = word?.slice(1)
    const capString = firstChar + remainingChars
    finalString += capString
    finalString += " "
  })

  return finalString || ""
}

export function makeFullName(firstname: string, lastName: string): string {
  // return `${firstname} ${lastName}`;
  return firstname + " " + lastName
}

export const isObjectEmpty = (objectName: Object) => {
  return Object.keys(objectName).length === 0
}

export const history: any = {
  navigate: null,
  location: null,
}

export function secondsToFancyTime(duration: any) {
  // Hours, minutes and seconds
  const hrs = ~~(duration / 3600)
  const mins = ~~((duration % 3600) / 60)
  const secs = ~~duration % 60

  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = ""

  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "")
  }

  ret += "" + mins + ":" + (secs < 10 ? "0" : "")
  ret += "" + secs

  return ret
}

function deepEqual(obj1: { [x: string]: any }, obj2: { [x: string]: any }) {
  // Check if both objects are of type object
  if (typeof obj1 !== "object" || typeof obj2 !== "object") {
    return obj1 === obj2
  }

  // Check if both objects have the same keys
  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)
  if (keys1.length !== keys2.length) {
    return false
  }

  // Check if the values of each key are equal
  for (let key of keys1) {
    if (!deepEqual(obj1[key], obj2[key])) {
      return false
    }
  }

  return true
}

export function isSubArraySubsetOf(mainArray: any[], subArray: any[]) {
  for (let element of subArray) {
    if (
      !mainArray.some((targetElement: any) => deepEqual(targetElement, element))
    ) {
      return false
    }
  }
  return true
}

function extractValue(row: any, accessorKey: string) {
  const keys = accessorKey.split(".")
  let value = row
  for (const key of keys) {
    if (value && typeof value === "object" && key in value) {
      value = value[key]
    } else {
      value = null
      break
    }
  }
  return value
}

export function extractTableData(headingCells: any, data: any) {
  const result: any = {
    headers: [],
    dataArray: [],
  }
  const datatype: any = {}

  // Generate headers
  for (const heading of headingCells) {
    if (heading.columnDefType === "group") {
      for (const column of heading.columns) {
        const header = `${heading.header} ${column.header}`
        if (
          column.accessorKey.includes("amount") ||
          column.accessorKey.includes("$")
        ) {
          datatype[column.accessorKey] = "$"
        }
        result.headers.push(header)
      }
    } else {
      if (heading.accessorKey) {
        if (
          heading.accessorKey.includes("amount") ||
          heading.accessorKey.includes("$")
        ) {
          datatype[heading.accessorKey] = "$"
        } else if (
          heading.accessorKey.includes("percent") ||
          heading.accessorKey.includes("%")
        ) {
          datatype[heading.accessorKey] = "%"
        }
      }
      result.headers.push(heading.header)
    }
  }

  // Generate data array
  for (const row of data) {
    const rowData = []
    for (const heading of headingCells) {
      if (heading.columnDefType === "group") {
        for (const column of heading.columns) {
          const accessorKey = column.accessorKey
          const value = accessorKey ? extractValue(row, accessorKey) : 0
          rowData.push(
            splitFirstCapPDF(
              datatype[heading.accessorKey] || "",
              value || "-",
              "_",
            ),
          )
        }
      } else {
        const accessorKey = heading.accessorKey
        const value = accessorKey ? extractValue(row, accessorKey) : 0
        rowData.push(
          splitFirstCapPDF(
            datatype[heading.accessorKey] || "",
            value || "-",
            "_",
          ),
        )
      }
    }
    result.dataArray.push(rowData)
  }

  return {
    headers: result.headers,
    dataArray: result.dataArray,
  }
}

export function splitFirstCapPDF(dataType: string, str: any, splitBy: string) {
  if (str == null) {
    return ""
  }

  const strAsString = String(str)
  const arrayOfWords = strAsString.split(splitBy)

  let finalString: string = ""

  arrayOfWords.forEach((word: any) => {
    const firstChar = word.charAt(0).toUpperCase()
    const remainingChars = word.slice(1)
    const capString = firstChar + remainingChars
    finalString += capString + " "
  })

  if (Number(finalString)) {
    if (dataType) {
      dataType === "$"
        ? (finalString = "$" + Number(finalString || 0).toLocaleString())
        : dataType === "%"
        ? (finalString = finalString + "%")
        : ""
    }

    return finalString
  }

  return finalString.trim()
}

export const csvConfig = (fileName?: string, title?: string) => {
  return {
    filename: fileName || "",
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: true,
    showColumnHeaders: true,
    title: title || "",
    showTitle: true,
    replaceUndefinedWith: "-",
  }
}

export function transformDataCSV(columns: any, data: any[]) {
  // Helper function to build the full header
  function buildFullHeader(groupHeader: any, columnHeader: any) {
    return groupHeader ? `${groupHeader} ${columnHeader}` : columnHeader
  }

  // Function to create the mapping of accessorKey to full header
  function createKeyToHeaderMap(columns: any[]) {
    const keyToHeader: any = {}

    columns.forEach(
      (group: {
        header: any
        columns: any[]
        columnDefType: string
        accessorKey: string | number
      }) => {
        const groupHeader = group.header

        if (group.columnDefType === "group") {
          if (group.columns) {
            group.columns.forEach(
              (column: { accessorKey: string | number; header: any }) => {
                keyToHeader[column.accessorKey] = buildFullHeader(
                  groupHeader,
                  column.header,
                )
              },
            )
          }
        } else {
          keyToHeader[group.accessorKey] = groupHeader
        }
      },
    )

    return keyToHeader
  }

  // Flatten the columns and create the accessorKey to header mapping
  const keyToHeader = createKeyToHeaderMap(columns)

  // Transform the data array
  const output = data.map((entry) => {
    const newEntry: any = {}

    Object.keys(keyToHeader).forEach((accessorKey) => {
      const keys = accessorKey.split(".")
      let value = entry
      keys.forEach((key) => {
        if (key === "is_highlight") {
          key = "value"
        }
        value = value ? value[key] : null
      })

      newEntry[keyToHeader[accessorKey]] =
        value !== null && value !== undefined && value !== "-"
          ? isNaN(parseInt(value))
            ? value
                .toString()
                .replaceAll("_", " ")
                .split(" ")
                .map(
                  (word: string) =>
                    word.charAt(0).toUpperCase() + word.slice(1),
                )
                .join(" ")
            : value
          : ""
    })

    return newEntry
  })

  if (output.length === 0) {
    const obj: any = {}
    Object.values(keyToHeader).map((ele: any) => (obj[ele] = ""))
    output.push(obj)
  }

  return output
}

export function assignTableId(
  parentId: string,
  tableId: string,
): HTMLTableElement | null {
  const parentElement = document.querySelector(`#${parentId}`)

  if (parentElement) {
    const tableElement = parentElement.querySelector("table")

    if (tableElement) {
      tableElement.setAttribute("id", tableId)
      // Step 3: Clone the table element
      const clonedTable = tableElement.cloneNode(true) as HTMLTableElement

      // Step 4: Remove only span elements whose content is "0" within the cloned table element
      const spanElements = clonedTable.querySelectorAll("span")
      spanElements.forEach((span) => {
        if (span.textContent === "0") {
          span.remove()
        }
      })

      // Step 5: Return the modified cloned table element
      return clonedTable
    } else {
      return null
    }
  } else {
    return null
  }
}
